import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ShieldCheck } from 'lucide-react';
import anuKingdomLogo from '../assets/images/anu-kingdom-logo.webp';
import './Auth.css';

const AdminLogin = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login, user } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (user) {
      if (user.role === 'admin' || user.role === 'sub-admin') {
        navigate('/admin');
      } else {
        setError('Access denied. Admin credentials required.');
      }
    }
  }, [user, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.email, formData.password);

    if (result.success) {
      // Check if user is admin or sub-admin
      const userData = JSON.parse(localStorage.getItem('user'));
      if (userData && (userData.role === 'admin' || userData.role === 'sub-admin')) {
        navigate('/admin');
      } else {
        setError('Access denied. Admin credentials required.');
        // Logout non-admin user
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.reload();
      }
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="auth-page admin-auth">
      <Link to="/" className="auth-brand" aria-label="Anu Kingdom home">
        <img src={anuKingdomLogo} alt="Anu Kingdom" />
        <span>ANU KINGDOM</span>
        <small>Learning Platform</small>
      </Link>
      <div className="auth-container">
        <div className="auth-header">
          <div className="role-icon admin-icon"><ShieldCheck size={25} aria-hidden="true" /></div>
          <h1>Admin Portal</h1>
          <p>Access the administration dashboard</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Admin Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="admin@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <Link to="/forgot-password" className="forgot-password-link">
              Forgot Password?
            </Link>
          </div>

          {error && <div className="error">{error}</div>}

          <button type="submit" className="btn-primary btn-admin" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In as Admin'}
          </button>

          <div className="auth-links">
            <Link to="/login" className="back-link">Student Login</Link>
            <Link to="/instructor/login" className="back-link">Instructor Login</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
